// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2RkjS","field":"styles_field__1znwp","textDescription":"styles_textDescription__ADpgS","loading":"styles_loading__3Dloq"};